// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__10Ois","filesListContainer":"PosDisputesFiles_filesListContainer__m8o5o","filesButton":"PosDisputesFiles_filesButton__3-htA"};